<template>
  <i :class="classes" :style="styles">
  </i>
</template>
<script>
const prefixCls = 'ushk-icon'

export default {
  name: 'Icon',
  props: {
    type: String,
    size: [Number, String],
    color: String
  },
  computed: {
    classes () {
      return `${prefixCls} ${prefixCls}_${this.type}`
    },
    styles () {
      let style = {}

      if (this.size) {
        style['font-size'] = `${this.size}px`
      }

      if (this.color) {
        style.color = this.color
      }

      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// icon.vue?08ed13bd